(function($){

	$(document).ready(function(){

		$('.articles-slider').each(function(index){
	
			if(!$(this).hasClass('slick-initialized')) {

				$prevArrow = $(this).parent().siblings('.articles-carousel-module__header').find('.articles-slider__navigation .slick-prev');
				$nextArrow = $(this).parent().siblings('.articles-carousel-module__header').find('.articles-slider__navigation .slick-next');

				update_progress($(this).siblings('.articles-slider__progress').find('.progress-bar'), 100 / $(this).find('.articles-slider__item').length);

				$slides_to_show = 1;

				if($(this).hasClass('noimages-layout')) {
					if($(window).width() >= 1440) {
						$slides_to_show = 3;
					} else if($(window).width() >= 768) {
						$slides_to_show = 2;
					}
				}

				$(this).slick({
			        slidesToShow: $slides_to_show,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: false,
			        variableWidth: true,
			        infinite: false,
			        prevArrow: $prevArrow,
			        nextArrow: $nextArrow
			    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			    	var $percent = ((nextSlide + $slides_to_show) / slick.slideCount) * 100;
			    	$progress_bar = $(event.currentTarget).siblings('.articles-slider__progress').find('.progress-bar');
			    	update_progress($progress_bar, $percent);
			    });  
			}
		});

		function update_progress($progress_bar, $progress_percent) {
			console.log('Progress Bar');
			console.log($progress_bar);
			$progress_bar.css('width', $progress_percent + '%');
		}

	});
	
})(jQuery);